import { render } from "./Section4.vue?vue&type=template&id=590585e9&scoped=true"
import script from "./Section4.vue?vue&type=script&lang=js"
export * from "./Section4.vue?vue&type=script&lang=js"

import "./Section4.vue?vue&type=style&index=0&id=590585e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-590585e9"]])

export default __exports__